import EventActionProto from '../event-action-proto';

module.exports = class EventUserNew extends EventActionProto {

    constructor(uid, data) {
        super(uid, data, false)
    }

    process() {
        gd.session.users.add([this.data],{parse:true})

        // required for Shared View
        // session user may be loaded after company users therefore companyUser.user remains null and need to be filled
        gd.session.companyUsers.filterByUser(this.data.id).map(cu=>{
            cu.user = gd.session.users.get(this.data.id)
        })

        super.process();
    }
};

